$( document ).ready(function() {
  
  // // monogram product gallery
  // if($(".product__media-wrapper .monogram-products li").length > 1 ){
  //   $('.product__media-wrapper .monogram-products').slick({
  //         dots: false,
  //         infinite: false,
  //         speed: 500,
  //         slidesToShow: 2,
  //         adaptiveHeight: false,
  //         responsive: [
  //         {
  //           breakpoint: 1024,
  //           settings: {
  //             slidesToShow: 2,
  //             infinite: true,
  //             dots: false
  //           }
  //         },
  //         {
  //           breakpoint: 600,
  //           settings: {
  //             slidesToShow: 2
  //           }
  //         },
  //         {
  //           breakpoint: 480,
  //           settings: {
  //             slidesToShow: 1
  //           }
  //         }
  //       ]
  //   });    
  // }

  // if( $('#product-gallery-monogram').length > 0 ){
    
  //   lightGallery(document.getElementById('product-gallery-monogram'), {
  //     selector: 'li:not(.slick-cloned) > .product-image',
  //     plugins: [lgZoom],
  //     zoomFromOrigin: true,
  //     enableThumbSwipe: false,
  //     enableThumbDrag: false,
  //     mobileSettings: {
  //       controls: true,
  //       showCloseIcon: true,
  //       download: false
  //     }
  //   });
    
  //   if (window.innerWidth <= 767 ) {
  //     //$('.mob-zoom-icon').click(function(){
  //     $(document).on('click','.mob-zoom-icon', function(e){
  //       e.preventDefault();
  //       var $this = $(this);
  //       $this.closest('.product__media-wrapper').find('.monogram-products').find('.slick-current.slick-active').find('.product-image')[0].click();
        
  //     });
  //   } 
  // }
  
  
  // dynaimc product gellaey
  if($(".product__media-wrapper .product-gallery li").length > 1 ){
    $('.product__media-wrapper .product-gallery').slick({
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 2,
          adaptiveHeight: false,
          responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              infinite: true,
              dots: false
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
    });    
  }

  if( $('#product-gallery').length > 0 ){
    
    lightGallery(document.getElementById('product-gallery'), {
      selector: 'li:not(.slick-cloned) > .product-image',
      plugins: [lgZoom],
      zoomFromOrigin: true,
      enableThumbSwipe: false,
      enableThumbDrag: false,
      mobileSettings: {
        controls: true,
        showCloseIcon: true,
        download: false
      }
    });
    
    if (window.innerWidth <= 767 ) {
      //$('.mob-zoom-icon').click(function(){
      $(document).on('click','.mob-zoom-icon', function(e){
        e.preventDefault();
        var $this = $(this);
        $this.closest('.product__media-wrapper').find('.product-gallery').find('.slick-current.slick-active').find('.product-image')[0].click();
        //$this.closest('.product__media-wrapper').find('.product-gallery').find('.slick-current.slick-active').find('.product-image').trigger('click');
        // var $slider = $('.product-gallery');
        // var $images = $slider.find('.product-image');        
        // //// Mark the first image as active initially
        // // $images.first().addClass('dd-active');
        // //// Add click event to mark the clicked image as active
        // // $images.on('click', function() {
        // //   $images.removeClass('dd-active');
        // //   $(this).addClass('dd-active');
        // // });
        // var $activeImage = $slider.find('.slick-current.slick-active > .product-image');
        // var index = $images.index($slider.find('.slick-current.slick-active > .product-image'));
        // console.log('index',index);
        // // Initialize lightGallery on the product slider
        // const plugin = lightGallery(document.getElementById('product-gallery'), {
        //   selector: 'li:not(.slick-cloned) > .product-image',
        //   plugins: [lgZoom],
        //   zoom: true,        
        //   index: index,  // Start lightGallery at the active image        
        // });          
        // // Open lightGallery at the active image
        // //$slider.data('lightGallery').openGallery(index);    
        // plugin.slide(index);
        
      });
    } 
  }  
      
  if($('.cstm_product_list .cstm-pro-list').length > 0 ){
    $('.cstm_product_list .cstm-pro-list').slick({
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: true
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: true
            }
          }
        ]
    });
  }    
  //  Tab js
  $('.wrp_nav li').click(function(){
    $('.wrp_nav li').removeClass('active');
    $(this).addClass('active');
    $('.tab_content').hide();
    var activeTab = $(this).attr('data-title');
    $("#"+activeTab).fadeIn();
    return false;
  });
  // Accordion js
  $('.wrp_accordion:nth-child(1) h4').addClass('active');
  $('.wrp_accordion:nth-child(1) .content').slideDown();
  $('.wrp_accordion h4').on('click', function() {
    if($(this).hasClass('active')) {
      $(this).siblings('.content').slideUp();
      $(this).removeClass('active');
    }
    else {
      $('.content').slideUp();
      $('.wrp_accordion h4').removeClass('active');
      $(this).siblings('.content').slideToggle();
      $(this).toggleClass('active');
    }
  }); 
  // progress bar
  jQuery(".relatedArticles").length && jQuery(window).on("scroll", function(t) {
    var i = jQuery(".article-template").height()
    , o = jQuery(this).scrollTop()
    , n = o / i;
    jQuery(".progress").css("width", 100 * n + "%")
  });
    
  // if($('.template-index .featured-collection .collection .product-grid').length > 0 ){
  //    $('.template-index .featured-collection .collection .product-grid').slick({
  //       slidesToShow: 5,
  //       slidesToScroll: 4,
  //       autoplay: true,
  //       autoplaySpeed: 5000,
  //       adaptiveHeight: true,
  //       infinite: false,
  //       rows: 1,
  //       responsive: [
  //       {
  //         breakpoint: 990,
  //         settings: {
  //           slidesToShow: 3,
  //           slidesToScroll: 3,
  //           arrows: false
  //         }
  //       },
  //       {
  //         breakpoint: 750,
  //         settings: {
  //           slidesToShow: 2,
  //           slidesToScroll: 2,
  //           arrows: true
  //         }
  //       }
  //     ]
  //   });
  // }
  

  var isALARendered;
  function ALAcheck() {
    isALARendered = setInterval(function () {
      customALA()
    }, 200);
  }
  ALAcheck();
  function customALA() {
  var selector = $('.related-products .product-grid');
    if(selector.length > 0) {
      clearInterval(isALARendered);        
       $('.related-products .product-grid').slick({
          slidesToShow: 4,
          slidesToScroll: 4,
          autoplay: true,
          autoplaySpeed: 5000,
          adaptiveHeight: true,
          infinite: false,
          responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              arrows: true
            }
          },
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              arrows: true
            }
          }
        ]
      });
    }  
  }


  if($('.tab_with_accordion .wrp_nav').length > 0 ){
    $('.tab_with_accordion .wrp_nav').slick({
      slidesToShow: 4.2,
      slidesToScroll: 4,
      infinite: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }

  if($('.footer-items-slider').length > 0 ){
    $('.footer-items-slider').slick({
        slidesToShow: 3,
        infinite: false,
        autoplay: true,
        dots: false,
        arrows: false,
        autoplaySpeed: 1900,
        responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            infinite: true,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            fade:true,
            dots: false
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
   

  
  // Footer Accordion Function
  //$(function () {
  // var Accordion = function (el, multiple) {
  //     this.el = el || {};
  //     //More Than One Menu Open
  //     this.multiple = multiple || false;
  
  //     var dropdownlink = this.el.find('.footer-block__heading');
  //     dropdownlink.on('click', {
  //       el: this.el,
  //       multiple: this.multiple
  //     },
  //       this.dropdown
  //     );
  // };
  
  // Accordion.prototype.dropdown = function (e) {
  //     var $el = e.data.el,
  //         $this = $(this),
  //         //ul submenuItems
  //         $next = $this.next();  
  //     $next.slideToggle();
  //     $this.parent().toggleClass('open');  
  //     if (!e.data.multiple) {
  //       //Show Only one Menu at the same time
  //       $el.find('.footer-block__details-content').not($next).slideUp().parent().removeClass('open');
  //     }
  // };
  // //Set Object
  // var accordion = new Accordion($('.footer__blocks-wrapper'), false);
  //});
  

  if( $('.complementary-products-slider').length > 0 ){
    $(".complementary-products-slider").slick({
      slidesToShow: 3,
      infinite:false,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000
    });
  }


  

  // $('.shop-pop-up-wrapper .close-box').click(function(){
  //   $(this).closest('.main-pop-up-box-wrap').removeClass('active');
  // });  
  // $('.shop-pop-up-btn').click(function(){
  //   $('.main-pop-up-box-wrap').addClass('active');
  // });


  
  $('.small-close-shop-btn').click(function(e){
    e.preventDefault();                                            
    $(this).closest('.shop-pop-up-btn').hide();
  });  

  $('.filter-desk .toggle-btn').click(function(e){
    $(this).toggleClass('is-active');
    $('.facets-vertical aside.facets-wrapper').toggleClass('is-active');
  });

  // Cart drawer top height
  if( $('.cst-cart-drawer').length > 0 ){
    var $headerHeight = $('.header').height();
    $('.cst-cart-drawer').css('top',$headerHeight);
    $('.cst-cart-drawer').css('height','calc(100% - '+$headerHeight+'px)');
  }
  
});
// End Document ready function


// close popup 
document.addEventListener('DOMContentLoaded', function() {
  var body = document.querySelector('.class_body');
  var closeButtons = document.querySelectorAll('.shop-pop-up-wrapper .close-box');  
  closeButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      var mainPopUpBoxWrap = button.closest('.main-pop-up-box-wrap');
      if (mainPopUpBoxWrap) {
        mainPopUpBoxWrap.classList.remove('active');
        body.classList.remove('active_popup');
      }
      setCookie("first_offer_popup","closed",1);
    });
  });
});

// add active in popup
if( $('.shop-pop-up-btn .custom__btn').length > 0 ){
  document.addEventListener('DOMContentLoaded', function() {
    var body = document.querySelector('.class_body');
    var popUpButton = document.querySelector('.shop-pop-up-btn .custom__btn');
    var popUpBox = document.querySelector('.main-pop-up-box-wrap');
    popUpButton.addEventListener('click', function() {
      $('.main-pop-up-box-wrap').show();
      popUpBox.classList.add('active');
      body.classList.add('active_popup');
    });
  });  
}

window.addEventListener('load', function() {
  if ( $('.main-pop-up-box-wrap').length > 0 ){
    $('.main-pop-up-box-wrap').show();
    document.querySelector('.main-pop-up-box-wrap').classList.add('active');
    document.querySelector('.class_body').classList.add('active_popup');  
    checkCookie();
  }
});

$(document).on('click', function(event) {
  if ( !$(event.target).closest('.active_popup .shop-pop-up-wrapper').length && !$(event.target).closest('.shop-pop-up-btn').length ) {
    $('.main-pop-up-box-wrap').removeClass('active');
    $('.class_body').removeClass('active_popup');
    $('.main-pop-up-box-wrap').hide();
    setCookie("first_offer_popup","closed",1);
  }
});


function setCookie(cname,cvalue,exdays) {  
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  //console.log('cval-', cvalue);
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function checkCookie() {
  var c_status=getCookie("first_offer_popup");
  if (c_status === 'closed') {
    $('.main-pop-up-box-wrap').hide();
    $('.main-pop-up-box-wrap').removeClass('active');
    $('.class_body').removeClass('active_popup');
  }  
}
checkCookie();

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// Footer Accordion Function
$(function () {
  if ($(window).width() < 575) {
    var Accordion = function (el, multiple) {
      this.el = el || {};
      //More Than One Menu Open
      this.multiple = multiple || false;
  
      var dropdownlink = this.el.find('.footer-block__heading');
      dropdownlink.on('click', {
        el: this.el,
        multiple: this.multiple
      },
        this.dropdown
      );
    };
    
    Accordion.prototype.dropdown = function (e) {
      var $el = e.data.el,
          $this = $(this),
          //ul submenuItems
          $next = $this.next();
  
      $next.slideToggle();
      $this.parent().toggleClass('open');
  
      if (!e.data.multiple) {
        //Show Only one Menu at the same time
        $el.find('.footer-block__details-content').not($next).slideUp().parent().removeClass('open');
      }
    };
    //Set Object
    var accordion = new Accordion($('.footer__blocks-wrapper'), false);  
  }
});

// if ($(window).width() < 990) {
  // $('.template-index .multicolumn .multicolumn-list').slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   infinite: true,
  //   arrows: false,
  //   dots: true
  // });
// }


$(document).on("click", "body", function(t) {
  if($(t.target).is('#collection-sort-custom_button')){
  	$("#collection-sort-custom").slideDown();
   } else {
    $('#collection-sort-custom').slideUp();
  }
});


  $(".set > a").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".content")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".content")
        .slideDown(200);
    }
  });

  // Custome code for mega menu on hover
  //var headerMenu = document.querySelector('.hover-mega-menu');
  //var headerMenu = document.querySelectorAll('.hover-mega-menu');
  // var headerMenu = document.getElementsByClassName('hover-mega-menu');
  // let isTouchDevice = false;
  // // Check if the device supports touch events
  // if ('ontouchstart' in window || navigator.maxTouchPoints) {
  //   isTouchDevice = true;
  // }
  // if (!isTouchDevice) {
  //   for (var i = 0; i < headerMenu.length; i++) {    
  //     headerMenu[i].addEventListener('mouseover', function (event) {
  //       if (event.target.tagName.toLowerCase() !== 'a') {
  //         this.classList.add('hoverstate');
  //         const detailsElement = this.querySelector('details');
  //         if (detailsElement) {
  //           detailsElement.setAttribute('open', '');
  //         }
  //         const summaryElement = this.querySelector('summary');
  //         if (summaryElement) {
  //           summaryElement.setAttribute('aria-expanded', 'true');
  //         }
  //       }
  //     });
  //   }
  //   for (var i = 0; i < headerMenu.length; i++) {
  //     headerMenu[i].addEventListener('mouseout', function (event) {
  //       headerMenu[i].classList.remove('hoverstate');
  //       if (
  //         event.target.tagName.toLowerCase() !== 'a' &&
  //         !headerMenu[i].contains(event.relatedTarget)
  //       ) {
  //         this.classList.remove('hoverstate');
  //         const detailsElement = this.querySelector('details');
  //         if (detailsElement) {
  //           detailsElement.removeAttribute('open');
  //         }
  //         const summaryElement = this.querySelector('summary');
  //         if (summaryElement) {
  //           summaryElement.setAttribute('aria-expanded', 'false');
  //         }
  //       }
  //     });
  //   }
  // }


  var headerMenu = $('.hover-mega-menu');
  let isTouchDevice = false;
  // Check if the device supports touch events
  if ('ontouchstart' in window || navigator.maxTouchPoints) {
    isTouchDevice = true;
  }
  if (!isTouchDevice) {
    headerMenu.on('mouseover', function(event) {
      if (event.target.tagName.toLowerCase() !== 'a') {
        $(this).addClass('hoverstate');
        var detailsElement = $(this).find('details');
        if (detailsElement.length) {
          detailsElement.attr('open', '');
        }
        var summaryElement = $(this).find('summary');
        if (summaryElement.length) {
          summaryElement.attr('aria-expanded', 'true');
        }
      }
    });
    headerMenu.on('mouseout', function(event) {
      $(this).removeClass('hoverstate');
      if (event.target.tagName.toLowerCase() !== 'a' && !$(this).has(event.relatedTarget).length) {
        $(this).removeClass('hoverstate');
        var detailsElement = $(this).find('details');
        if (detailsElement.length) {
          detailsElement.removeAttr('open');
        }
        var summaryElement = $(this).find('summary');
        if (summaryElement.length) {
          summaryElement.attr('aria-expanded', 'false');
        }
      }
    });
  }




// Game code below JS
if ($(".template-index .newsletter-with-banner ").length > 0 ){
document.addEventListener("DOMContentLoaded", function () {
  // Your JavaScript function call here
  dataInitialization();
});

const foodItemsArray = [1, 2, 4, 5, 6, 7, 8, 9, 10];
var speed;
var snakeBody, food, direction, allowedToMove, isPlaying, allpos;
function dataInitialization() {
  console.log("call");
  allpos = [];
  allFoodEat = [];
  speed = 2;
  var map;
  var play;
  // Rest of your initialization logic goes here...
}

function randomElementFromArray(arr) {
  const element = arr[Math.floor(Math.random() * arr.length)];
  return element;
}

function initializeVariables() {
  snakeBody = [[0, 0]];
  food = 0;
  direction = "Right";
  allowedToMove = false;
  isPlaying = false;
}

// Creating the map and initializing variables
function initializeGameState(mapElementId) {
  map = document.getElementById(mapElementId);
  initializeVariables();

  // Generating the map pixels
  
  for (var i = 0; i < 100; i++) {
    var pixel = document.createElement("div");
    pixel.setAttribute("class", "pixel");
    map.appendChild(pixel);
  }

  // Generating the snake body and food
  map.children[0].classList.add("snake-body");
  generateFood();
}

function generateFood() {
  // To prevent generating food over the snake
  while (map.children[food].classList.contains("snake-body")) {
    food = Math.floor(Math.random() * 100);
  }
  // Placing food on the map
  map.children[food].classList.add("food");
  var foodItem = randomElementFromArray(foodItemsArray);
  console.log("foodItem", foodItem);
  map.children[food].classList.add("cls_" + foodItem);
  map.children[food].setAttribute("data-id", foodItem);
}

function startGame() {
  if (!isPlaying) {
    allowedToMove = true;
    play = setInterval(updatePosition, 500 / speed);
    document.getElementById("menu").style.display = "none";
    document.getElementById("map").style.display = "";
    isPlaying = true;
  }
}

function pauseGame() {
  if (isPlaying) {
    allowedToMove = false;
    clearInterval(play);
    document.getElementById("menu-text").innerText =
      "PAUSED\nPress ENTER to resume";
    document.getElementById("menu").style.display = "";
    document.getElementById("map").style.display = "none";
    isPlaying = false;
  }
}

function gameOver() {
  // return  true;
  clearInterval(play);
  playerinsert(snakeBody.length - 1);
  document.getElementById("menu-text").innerText =
    "Game Over\nYour Score: " +
    (snakeBody.length - 1) +
    "\nPress ENTER to restart";
  document.getElementById("menu").style.display = "";
  document.getElementById("map").style.display = "none";
  map.innerText = ""; // Clearing the map
  initializeGameState(map.id); // Re-generating the map
  dataInitialization();
}

function updatePosition() {
  var newPosR, newPosC;
  var head = snakeBody[snakeBody.length - 1];

  switch (direction) {
    case "Up":
      newPosR = head[0] - 1;
      newPosC = head[1];
      break;
    case "Down":
      newPosR = head[0] + 1;
      newPosC = head[1];
      break;
    case "Left":
      newPosR = head[0];
      newPosC = head[1] - 1;
      break;
    case "Right":
      newPosR = head[0];
      newPosC = head[1] + 1;
      break;
    default:
      break;
  }
  // Checking if snake hit the wall
  if (newPosR < 0 || newPosR > 9 || newPosC < 0 || newPosC > 9) {
    gameOver();
  } else {
    snakeBody.push([newPosR, newPosC]);
    updateScreen();
    allowedToMove = true;
  }
}

function updateScreen() {
  // $('.pixel').removeClass('snake-tail');
  var tailArray = snakeBody.shift();
  var tail = parseInt(tailArray[0] + "" + tailArray[1]);
  // map.children[tail].classList.add("snake-tail");
  var headArray = snakeBody[snakeBody.length - 1];
  var head = parseInt(headArray[0] + "" + headArray[1]);
  if (map.children[head].classList.contains("snake-body")) {
    gameOver();
  } else {
    map.children[head].classList.add("pixel");
    map.children[head].classList.add("snake-body");

    map.children[head].classList.add("snake-img");

    allpos.unshift(head);
    // Removes the tail block
    map.children[tail].classList.remove("snake-body");
    var index_tail = allpos.indexOf(tail);
    if (index_tail > -1) {
      // only splice array when item is found
      allpos.splice(index_tail, 1);
    }
    var tmp_i = 0;
    let sortedArr = allpos;
    sortedArr.forEach(function (item_n, index_n) {
      // Remove all classes that start with "cls_"
      map.children[item_n].classList.remove(
        ...Array.from(map.children[item_n].classList).filter((cls) =>
          cls.startsWith("cls_")
        )
      );
      // Add the new class
      map.children[item_n].classList.add("cls_" + allFoodEat[tmp_i - 1]);
      tmp_i = tmp_i + 1;
    });

    // If snake eats the food
    if (head == food) {
      map.children[food].classList.remove("food");
      get_food_num = map.children[food].getAttribute("data-id");
      map.children[food].classList.remove("cls_" + get_food_num);
      allFoodEat.unshift(get_food_num);
      map.children[food].innerHTML = "";
      snakeBody.unshift(tailArray);
      // Checking if the snake reached its max size
      snakeBody.length == 100 && gameOver();
      generateFood();
    }
  }
}
// CONTROLS
$(document).keyup(function (e) {
  console.log("check");
  console.log("e.which", e.which);
  if (
    e.which == "38" ||
    e.which == "40" ||
    e.which == "37" ||
    e.which == "39" ||
    e.which == "27"
  ) {
    //up arrow key
    keyPress(e);
  }
});
function keyPress(e) {
  console.log("tested");

  e.preventDefault();
  e = e || window.event;

  // Escape key is pressed
  e.keyCode == 27 && pauseGame();

  // Enter key is pressed
  e.keyCode == 13 && startGame();
  let up = 38;
  let down = 40;
  let left = 37;
  let right = 39;

  if (allowedToMove) {
    allowedToMove = false;
    switch (e.keyCode) {
      case left:
        direction != "Right" && (direction = "Left");
        break;
      case up:
        direction != "Down" && (direction = "Up");
        break;
      case right:
        direction != "Left" && (direction = "Right");
        break;
      case down:
        direction != "Up" && (direction = "Down");
        break;
      default:
        allowedToMove = true;
        break;
    }
  }
}

// Initiates the game

initializeGameState("map");
var Score = 0;
function playerinsert(score) {
  Score = score;
  $("#popUpModel").css("display", "block");
}
function submitForm() {
  console.log("Score", Score);
  console.log("test", snakeBody.length);
  var formData = {
    name: $("#name").val(),
    email: $("#email").val(),
    score: Score,
  };

  $.ajax({
    type: "POST",
    url: "insertGameUser.php",
    data: formData,
    success: function (response) {
      if (response.success == true) {
        $("#popUpModel").css("display", "none");
      } else {
        alert(response.message);
      }
    },
    error: function (error) {
      alert(error.responseText);
      console.log("Error:", error);
    },
  });
}
// pop modal
$(".show-button").click(function () {
  $(".popup").fadeIn(500);
});
$(".close").click(function () {
  $(".popup").fadeOut(500);
});
document.getElementById("down").addEventListener("click", function () {
  // Create a dummy event object with keyCode 40 (down arrow)
  var dummyEvent = new Event("keydown");
  dummyEvent.keyCode = 40;

  // Call the keyPress function with the dummy event
  keyPress(dummyEvent);
});

// Event listener for the "left" button
document.getElementById("left").addEventListener("click", function () {
  // Create a dummy event object with keyCode 37 (left arrow)
  var dummyEvent = new Event("keydown");
  dummyEvent.keyCode = 37;

  // Call the keyPress function with the dummy event
  keyPress(dummyEvent);
});

// Event listener for the "up" button
document.getElementById("up").addEventListener("click", function () {
  // Create a dummy event object with keyCode 38 (up arrow)
  var dummyEvent = new Event("keydown");
  dummyEvent.keyCode = 38;

  // Call the keyPress function with the dummy event
  keyPress(dummyEvent);
});

// Event listener for the "right" button
document.getElementById("right").addEventListener("click", function () {
  // Create a dummy event object with keyCode 39 (right arrow)
  var dummyEvent = new Event("keydown");
  dummyEvent.keyCode = 39;

  // Call the keyPress function with the dummy event
  keyPress(dummyEvent);
});
$("#menu").on("click", function () {
  event.preventDefault(); // Prevent the default behavior
  event.stopPropagation();
  event.stopImmediatePropagation();
  startGame();
});

  var cw = $('.iframe-content .container-frame').width();

  console.log('cw',cw);
  $('.iframe-content .container-frame').css({
    'height': cw + 'px'
  });

  $(window).on('resize', function(){
    console.log('resize');
    var cw = $('.iframe-content .container-frame').width();
    $('.iframe-content .container-frame').css({
      'height': cw + 'px'
    });
  });
}








function check_giftWrap(){
  // console.log('check_giftWrap called');
  var $giftWrapCheckbox = $('#gift-wrap-checkbox');
  var $giftNoteContainer = $('#gift-note-container');
  var $giftNoteTextarea = $('#gift-note');
  var giftProductVariantId = $('.cart-drawer__gift-wrap').data('gift-vid');
    
  $.getJSON('/cart.js', function(cart) {
    console.log('cart',cart);    
    var check_gift = cart.items.find(function(item) {
      return item.variant_id == giftProductVariantId;
    });
    console.log('check_gift=>',check_gift);    
    //if( !check_gift && $giftWrapCheckbox.is(':checked') && cart.item_count >= 1 ){
    if( !check_gift && $('#gift-wrap-checkbox.gift_active').length > 0 && cart.item_count >= 1 ){
      console.log('check-add');
      addGiftProduct(giftProductVariantId);
    }    
    if( check_gift && $('#gift-wrap-checkbox.gift_active').length == 0 ){
      console.log('check-remove');
      removeGiftProduct(giftProductVariantId);
    }
    if( cart.item_count == 0 ){
      var formData = {
        'attributes': {
          'gift-wrap': 'No',
          'gift-note': ''
        }
      }
	   $.ajax({
	      type: 'POST',
	      url: '/cart/update.js',
	      data: formData,
	      dataType: 'json'
	    });
	    console.log('cart cleared');
    }
  });
  
  if ($giftWrapCheckbox.length) {
    // $giftWrapCheckbox.on('change', function() {    
    $(document).on('click', '#gift-wrap-checkbox', function(){
      $('#gift-wrap-checkbox').prop('disabled', true);
      $('.loading__spinner_cart').removeClass('hidden');
    //$('#gift-wrap-checkbox').unbind('click').click(function() {
      var $this = $(this);
      console.log('1Checked?',$giftWrapCheckbox.is(':checked'));
      $this.toggleClass('gift_active');

      $this.closest('.gift-wrap-checkbox-wrap').css('pointer-events', 'none');
      setTimeout(function() { $this.closest('.gift-wrap-checkbox-wrap').css('pointer-events', 'all'); },2000);
     // setTimeout(function() {
        
        console.log('2Checked?',$('#gift-wrap-checkbox.gift_active').length);
        
        //if ($giftWrapCheckbox.is(':checked')) {
        if ( $('#gift-wrap-checkbox.gift_active').length > 0 ) {
          console.log('addGiftProduct',giftProductVariantId);
          $this.closest('.cart-drawer__gift-wrap').find('#gift-note-container').fadeIn('slow');
          addGiftProduct(giftProductVariantId);
        } else {
          console.log('removeGiftProduct',giftProductVariantId);
          //giftNoteContainer.fadeOut('slow');
          $this.closest('.cart-drawer__gift-wrap').find('#gift-note-container').hide();
          //$giftNoteTextarea.val('');
          document.getElementById("gift-note").value = '';
          var maxLen = parseInt($('#gift-note').attr('maxlength'));
          $('#gift-note-container .message-counter').text(0+'/'+maxLen);
          removeGiftProduct(giftProductVariantId);
        }
    //  }, 500);
      setTimeout(function() {
        updateCartAttributes();
      }, 400);
    });
  }

  if ($giftNoteTextarea.length) {
    $(document).on('blur', '#gift-note', function () {
    //$giftNoteTextarea.on('blur', function() {
      updateCartAttributes();
    });
  }
  function updateCartAttributes() {
    var formData = {
      'attributes': {
        'gift-wrap':  $('#gift-wrap-checkbox.gift_active').length ? 'Yes' : 'No',
        'gift-note': document.getElementById("gift-note").value
      }
    };
    console.log('FD=',formData);
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: JSON.stringify(formData),
      dataType: 'json',
      contentType: 'application/json',
      success: function(cart) {
         console.log('Cart totals updated:', cart);
        // Optionally, refresh the cart drawer content here 
        
         // Extract the total amount from the cart data
            var totalAmount = cart.total_price / 100; // total_price is in cents, so divide by 100 to get dollars

            // Format the total amount as GBP currency
            var formattedAmount = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(totalAmount)+' GBP';

            // Set the formatted amount into the HTML element
            $('.totals__total-value').text(formattedAmount);
        
      },
      error: function(error) {
        console.error('Error updating cart:', error);
      }
    });
  }
  // updateCartAttributes();

  function addGiftProduct(variantId) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {id:variantId,quantity:1},
      dataType: 'json',
      success: function(item) {
        console.log('Gift product added:', item);
        
        setTimeout(function() {
          $.ajax({
            url: window.location.href,
            method: "GET",
            dataType: "html",
            success: function(htmlContent) {
              let doc = new DOMParser().parseFromString(htmlContent, "text/html");
              let cartDrawerElement = doc.querySelector("#CartDrawer #CartDrawer-CartItems");
              cartDrawerElement && ($("#CartDrawer #CartDrawer-CartItems").replaceWith(cartDrawerElement.outerHTML));
                updateCartAttributes();
              $('#gift-wrap-checkbox').prop('disabled', false);
              $('.loading__spinner_cart').addClass('hidden');
              if( $('.template-cart').length > 0 ){
                // let cartPage_doc = new DOMParser().parseFromString(htmlContent, "text/html");
                // let cartPageElement = doc.querySelector("cart-items .cart__contents");
                // cartPageElement && ($("cart-items .cart__contents").replaceWith(cartPageElement.outerHTML));
                location.reload();
              }
            },
            error: function(error) {
              console.error("Error fetching and modifying HTML:", error);
            }
          });
        }, 300);
      },
      error: function(error) {
        console.error('Error adding gift product:', error);
      }
    });
  }

  function removeGiftProduct(variantId) {
    //$.getJSON('/cart.js', function(cart) {
      var item = variantId;
      // var item = cart.items.find(function(item) {
      //   return item.variant_id == variantId;
      // });
      console.log("Removeitem:", item);

      if (item) {
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {id:item,quantity: 0},
          dataType: 'json',
          success: function(cart) {
            console.log('Gift product removed:', cart);
            
            setTimeout(function() {
              $.ajax({
                url: window.location.href,
                method: "GET",
                dataType: "html",
                success: function(htmlContent) {
                  let doc = new DOMParser().parseFromString(htmlContent, "text/html");
                  let cartDrawerElement = doc.querySelector("#CartDrawer #CartDrawer-CartItems");
                  cartDrawerElement && ($("#CartDrawer #CartDrawer-CartItems").replaceWith(cartDrawerElement.outerHTML));
                  updateCartAttributes();
                  $('#gift-wrap-checkbox').prop('disabled', false);
                  $('.loading__spinner_cart').addClass('hidden');
                  if( $('.template-cart').length > 0 ){
                    // let cartPage_doc = new DOMParser().parseFromString(htmlContent, "text/html");
                    // let cartPageElement = doc.querySelector("cart-items .cart__contents");
                    // cartPageElement && ($("cart-items .cart__contents").replaceWith(cartPageElement.outerHTML));
                    location.reload();
                  }
                },
                error: function(error) {
                  console.error("Error fetching and modifying HTML:", error);
                }
              });
            }, 300);
          },
          error: function(error) {
            console.error('Error removing gift product:', error);
          }
        });
      }
    //});
  }

  function countChar() {
    //$('#gift-note').on('keyup', function(event) {
    $(document).on('keyup', '#gift-note', function () {
      var maxLen = parseInt($(this).attr('maxlength'));
      var len = $(this).val().length;
      if (len >= maxLen) {
        val.value = val.value.substring(0, maxLen);
      } else {
        $('#gift-note-container .message-counter').text(len+'/'+maxLen);
      }
    });
  }
  countChar();
  

}

check_giftWrap();







  

